import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  catchError: false,
  errType: '',
  errStatus: 0,
  errCode: '',
  errMessage: ''
}

const handleErrorSlice = createSlice({
  name: 'handleError',
  initialState,
  reducers: {
    setErrorMsg (state, action) {
      const { payload } = action
      return { ...initialState, ...payload }
    },
    setClearErrorMsg () {
      return { ...initialState }
    }
  }
})

export const { setErrorMsg, setClearErrorMsg } = handleErrorSlice.actions
export default handleErrorSlice.reducer
